import {
  TableActionsCreator,
  TABLE_ACTIONS_TYPE,
  TABLE_ACTION_COMPONENTS
} from '@ublique/components'
import { ModalActions } from '@ublique/platform'

import {
  getUserPreferences,
  updateUserDataPreferences
} from '@ublique/platform/services/api/user'
import { COLUMN_TABLE_HEADER_NAME } from '../constants'
import { userPreferencesStore } from '@ublique/platform/services/state'

export const tableActionsConfig = ({
  btnFilterT,
  gridApi,
  t,
  isActiveTabular,
  setIsActiveTabular,
  enableFilterBtn,
  filterName
}) => {
  const { openModal } = ModalActions

  const builder = new TableActionsCreator() //

  if (filterName) {
    builder.addUbliqueBtn({
      type: TABLE_ACTIONS_TYPE.PLATFORM_COMPONENTS,
      action: () => {},
      componentProps: {
        t: btnFilterT,
        filterName,
        component: TABLE_ACTION_COMPONENTS.ShowActiveNameFilter
      }
    })
  }

  //add
  builder.addUbliqueBtn({
    type: TABLE_ACTIONS_TYPE.PLATFORM_COMPONENTS,
    action: () => {},
    componentProps: {
      openModal: openModal,
      updateUserDataPreferences: updateUserDataPreferences,
      userPreferences: getUserPreferences,
      ...enableFilterBtn,
      component: TABLE_ACTION_COMPONENTS.ColumnsFilterButtonTable
    }
  })

  /*  builder.addUbliqueBtn({
    id: 'tabular-btn',
    label: isActiveTabular ? t('DISABLE TABULAR') : t('ENABLE TABULAR'),
    action: tableActions.enableTabular,
    componentProps: {}
  }) */

  builder.addUbliqueBtn({
    type: TABLE_ACTIONS_TYPE.PLATFORM_COMPONENTS,
    action: () => {},
    componentProps: {
      t: btnFilterT,
      gridApi,
      isActiveTabular,
      setIsActiveTabular,
      component: TABLE_ACTION_COMPONENTS.TabularButton
    }
  })

  return builder.getTableButtons()
}
export const defaultColDef = {
  filter: true,
  resizable: true,
  sortable: true
}

export const getColumnsDef = (t) => {
  const columnDefs = [
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.SETTIMANACOMMERCIALE}`),
      colId: 'settimanaCommerciale',
      field: 'settimanaCommerciale',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.NOMEIPOTESI}`),
      colId: 'nomeIpotesi',
      field: 'nomeIpotesi',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.STATO}`),
      colId: 'stato',
      field: 'stato',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.ARTICOLO}`),
      colId: 'articolo',
      field: 'articolo',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.CATEGORY}`),
      colId: 'category',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter',
      valueGetter: ({ data }) => {
        return `${data?.category}-${data?.categoryDesc}`
      }
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.ENTE}`),
      colId: 'ente',
      field: 'ente',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.ENTEDESCENTE}`),
      colId: 'enteDescEnte',
      field: 'enteDesc',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.ENTEANDDESC}`),
      colId: 'enteAndDescEnte',
      valueGetter: ({ data }) => {
        return `${data?.ente}-${data?.enteDesc}`
      },
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.QTY}`),
      colId: 'qty', //stock
      field: 'qty',
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      cellStyle: { textAlign: 'right' },

      filter: 'agNumberColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.VALORE}`),

      colId: 'valore',
      field: 'valore',
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      cellStyle: { textAlign: 'right' },

      filter: 'agNumberColumnFilter',
      valueFormatter: function (params) {
        if (isNaN(params.value)) return ''

        const formattedValue = new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(params.value)
        // Your formatting logic here, for example, formatting to two decimal places
        return formattedValue
      }
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.ZONA}`),
      colId: 'zona',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter',
      valueGetter: ({ data }) => {
        return `${data?.zona}-${data?.zonaDesc}`
      }
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.EXPLENABILITY}`),
      colId: 'explenability',
      field: 'explenability',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.APC}`),
      colId: 'apc',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter',
      valueGetter: ({ data }) => {
        return `${data?.apc}-${data?.apcDesc}`
      }
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.SEASON}`),
      colId: 'season',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter',
      valueGetter: ({ data }) => {
        return `${data?.season}-${data?.seasonDesc}`
      }
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.COMMODITY}`),
      colId: 'commodity',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter',
      valueGetter: ({ data }) => {
        return `${data?.commodity}-${data?.commodityDesc}`
      }
    },

    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.ITRP}`),
      colId: 'itrp',
      field: 'itrp',
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      cellStyle: { textAlign: 'right' },
      filter: 'agNumberColumnFilter',
      valueFormatter: (params) => {
        if (isNaN(params.value)) return ''

        const formattedValue = new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(params.value)
        return formattedValue
      }
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.MANDATORYARTICLE}`),
      colId: 'mandatoryArticle',
      field: 'mandatoryArticle',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.ARTICOLO_DESC}`),
      colId: 'articoloDesc',
      field: 'articoloDesc',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.STRUCTURE}`),
      colId: 'struttura',
      field: 'struttura',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(`${COLUMN_TABLE_HEADER_NAME.SOURCE}`),
      colId: 'source',
      field: 'source',
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agSetColumnFilter'
    }
  ]

  return columnDefs
}

export const findAndSetAppliedFilter = (params) => {
  const pageUserConfig =
    userPreferencesStore.get().output?.filteredOutputColumns['report_pivot'] ??
    []

  const pageUserConfigSelected = pageUserConfig?.find(
    ({ selected }) => selected
  )
  if (pageUserConfigSelected) {
    if (pageUserConfigSelected?.tabular) {
      params.api.gridCore.gridOptions.groupDefaultExpanded = 5
      params.api.gridCore.gridOptions.groupHideOpenParents = true
    }
    const model = pageUserConfigSelected?.model

    params?.api?.gridCore?.columnApi?.resetColumnState()
    params?.api?.gridCore?.columnApi?.setColumnState(model)

    const pivotFilterInfo = pageUserConfigSelected?.filter
    if (pivotFilterInfo) {
      params.api.gridCore.filterManager.setFilterModel(pivotFilterInfo)
      params.api.gridCore.filterManager.onFilterChanged()
    }
  }
}
